import React from 'react';
import PropTypes from 'prop-types';
import { Route, Link, withRouter } from "react-router-dom";
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography';
import AddCircleIcon from '@material-ui/icons/AddCircle'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button'
import HelpIcon from '@material-ui/icons/Help'
import Paper from '@material-ui/core/Paper'
import ReactQuill from 'react-quill'

import 'react-quill/dist/quill.bubble.css'

const modules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline','strike', 'blockquote'],
      [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
      ['clean']
    ],
  }

const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
  ]

const removebutton = {
  float: 'right'
}

export default class Answer extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      writing: false
    }
  }



  render () {
    const {text, active, correct, modAnswer,index} = this.props
    return (
      <div className={'Antwort'+(index+1)}>
        <FormControlLabel
            control={
                  <Checkbox
                    checked={active}
                    onClick={e => modAnswer({...this.props,active : !active})}
                  />
            }
            label="aktiv"
        />
        <FormControlLabel
            control={
                  <Checkbox
                    checked={correct}
                    onClick={e => modAnswer({...this.props,correct : !correct})}
                  />
            }
            label="richtig"
        />
        <CloseIcon style={removebutton} onClick={this.props.removeAnswer}/>
          <ReactQuill placeholder="Antwort eingeben"
              theme="bubble"
              modules={modules}
              formats={formats}
              value={text}
              bounds= {'.Antwort'+(index+1)}
              onFocus = {e => this.setState({writing : true})}
              onBlur = {e => setTimeout(() => {this.setState({writing: false})},100)}
              onChange={value => this.state.writing && modAnswer({...this.props,text:value})}
          />
      </div>

    )
  }


}
